import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

export const assetsObjectTypeSettingsEntryPoint = createEntryPoint({
	root: JSResourceForInteraction(
		() =>
			import(/* webpackChunkName: "async-assets-object-type-settings-entrypoint" */ './index.tsx'),
	),
	getPreloadProps: () => ({}),
});
